import React, {useState, useEffect} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    Image,
    Header,
    Item,
    Card,
    Icon
} from 'semantic-ui-react'

import withRouter from "../common/withRouter";


const Landing = (props) => {

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;


    const items = [
        {
            header: 'Small',
            description:
                'Small Rug • Lamp • Fan Skateboard • Poster Tube Clothes Rack • Misc. Small Item',
            price: '$50',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
        {
            header: 'Medium',
            description:
                'Microwave • Mattress Pad Vacuum, Mop or Broom Small Box, Bin or Tote under 4 cubic feet',
            price: '$55',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
        {
            header: 'Large',
            description:
                'Nightstand • Small table Large Rug • Boom Box Cart with Drawers • Suitcase Large Tote, Box or Duffle Bag',
            price: '$65',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
        {
            header: 'XL',
            description:
                'Desk Chair • Guitar • Bike Mini Fridge • Bookshelf • Bed Frame Skis/Snowboard • Mirror or Artwork XL Box, Bin, Trunk or Misc. Item',
            price: '$80',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
        {
            header: 'XXL',
            description:
                'Sofa Chair • Large Table/Desk Mattress • Box Spring TV under 45" • Bean Bag Chair',
            price: '$125',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
        {
            header: 'XXXL',
            description:
                'Wardrobe • Couch or Futon King Size Mattress • Large Dresser TV over 45" • Giant Bean Bag Chair',
            price: '$200',
            unit: 'per item/per term',
            duration: 'Storage for 4 months',
        },
    ]

    return (
        <React.Fragment>
            {/*<Container style={{marginTop: '3em', alignContent: "center"}}>*/}
            <Grid doubling columns={"equal"}
                  style={{
                      padding: 20,
                      alignContent: "center",
                      paddingLeft: isMobile ? 20 : 100,
                      paddingRight: isMobile ? 20 : 100
                  }}>

                <GridColumn style={{
                    padding: 0,
                    paddingTop: 15,
                    textAlign: isMobile ? "center" : "initial",
                    display:"flex",
                    alignItems:"center"
                }}>
                    <Image style={{height: 50}}src={process.env.PUBLIC_URL + '/amston_commercial_logo_3Uv_icon.ico'}/>
                    <Header as={'h4'} style={{cursor: "pointer", margin: "0px 15px"}}>
                        Amston Student Storage
                    </Header>
                </GridColumn>
                <GridColumn style={{
                    padding: 0,
                    paddingTop: 5,
                    alignContent: "center",
                    textAlign: isMobile ? "center" : "initial",
                    float: "right"
                }}>
                    <Button className={'menu_button'}
                            onClick={()=>{
                                props.router.navigate('/getstarted')

                            }}
                            style={{float: "right"}}>
                        Get Started</Button>
                </GridColumn>
            </Grid>
            {/*</Container>*/}
            <Menu inverted
                  style={{backgroundColor: "#990001", padding: 30}}>
                <Container style={{display: "flex", flexDirection: "column"}}>
                    <div style={{display: "flex", flexDirection: "column", marginBottom: 0, alignItems: "center"}}>
                        <Header as={'h1'} style={{cursor: "pointer", color: "#FFE495"}}>
                            Simplify Your Student Move with AMSTON
                        </Header>
                        <p className={"subheader"} style={{color: "white"}}>
                            We deliver boxes, pick up your packed items, store them safely all summer, then return them
                            when school resumes!
                        </p>
                    </div>
                </Container>
            </Menu>
            <Container>
                <div style={{
                    marginBottom: '3em',
                    borderRadius: 20,
                    padding: isMobile ? 1 : 40,
                    backgroundColor: "white"
                }}>
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            fontSize: 16,
                            textAlign: "center"
                        }}>
                        <Grid doubling columns={2}>
                            <GridColumn width={8} style={{justifyContent: "center", padding: isMobile ? 30 : 0}}>
                                <Item.Group unstackable>
                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/open-box.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Free Boxes & Supplier</Item.Header>
                                            <Item.Extra>We bring sturdy boxes right to your dorm or campus
                                                apartment.</Item.Extra>
                                        </Item.Content>
                                    </Item>

                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/close-box.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Easy Packing</Item.Header>
                                            <Item.Extra>You pack your personal items, clothes, electronics, furniture...
                                                whatever you need stored.</Item.Extra>
                                        </Item.Content>
                                    </Item>
                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/storage.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Secure Storage</Item.Header>
                                            <Item.Extra>We transport your belongings to our secure, climate-controlled
                                                facility for the summer.</Item.Extra>
                                        </Item.Content>
                                    </Item>
                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/deliver.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Redelivery in the Fall</Item.Header>
                                            <Item.Extra>When you return for the new school year, we deliver everything
                                                right back to campus.</Item.Extra>
                                        </Item.Content>
                                    </Item>
                                </Item.Group>

                                <Button className={'menu_button'}
                                        onClick={()=>{
                                            props.router.navigate('/getstarted')

                                        }}>
                                    Get a FREE Estimate Today!</Button>
                            </GridColumn>

                            <GridColumn width={8} style={{alignContent: "center", padding: isMobile ? 30 : 10}}>
                                <Image style={{width: 700, height: "auto"}}
                                       src={process.env.PUBLIC_URL + '/Amston-Student-Hero-Image.jpeg'}/>
                                <p className={"extra"}>All you have to do is pack! We supply the boxes, the movers, the
                                    truck, and the storage, all for one low price with no hidden fees.</p>

                            </GridColumn>
                        </Grid>
                    </div>
                </div>
                <Container style={{display: "flex", flexDirection: "column"}}>
                    <div style={{display: "flex", flexDirection: "column", marginBottom: 0, alignItems: "center"}}>
                        <Header as={'h3'} style={{cursor: "pointer",}}>
                            Affordable Pricing
                        </Header>
                        <p className={"subheader"} style={{color: "grey"}}>
                            No Hidden Fees!
                        </p>
                        <Card.Group itemsPerRow={3} doubling stackable>
                            {items.map(item => {
                                return (<Card raised>
                                    <Card.Content style={{
                                        backgroundColor: "#990001",
                                        color: "white",
                                        maxHeight: 60
                                    }}><Header as={'h3'}
                                               style={{cursor: "pointer", color: "white", textAlign: "center"}}>
                                        {item.header}
                                    </Header></Card.Content>
                                    <Card.Content style={{textAlign: "center"}}>
                                        <p className={"extra"}><span className={"price"}>{item.price}</span> {item.unit}
                                        </p>
                                        <p><span className={"duration"}>{item.duration}</span></p>
                                        <hr style={{height: 2, backgroundColor: "#FF8F2D", border: "none"}}/>
                                        <p className={"extra"}>{item.description}</p>
                                    </Card.Content>
                                </Card>)
                            })}
                        </Card.Group>


                    </div>
                </Container>
                <br/>
                <br/>
                <Container style={{display: "flex", flexDirection: "column", backgroundColor: "#990001"}}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: 0,
                        alignItems: "center",
                        padding: 30
                    }}>
                        <Header as={'h3'} style={{cursor: "pointer", color: "white"}}>
                            One Flat Rate
                        </Header>
                        <p className={"one-flat-rate"}>
                            Amston Student Storage makes it easy and affordable to store your belongings over the summer with <strong>flat-rate pricing</strong> and <strong>no
                            hidden fees</strong>. Whether you need to store a small item like a lamp or a large item such as a couch, we offer a range of options to fit your needs, with prices starting at just $50 per item for 4 months of storage. Plus, enjoy the convenience of <strong>free
                            box delivery</strong> and <strong>free pickup and delivery</strong>, making the entire process simple and stress-free. With <strong>affordable
                            storage options</strong>, you can trust Amston to securely store your items without worrying about additional charges.
                        </p>
                    </div>
                </Container>
                <div style={{
                    marginBottom: '3em',
                    borderRadius: 20,
                    padding: isMobile ? 1 : 40,
                    backgroundColor: "white"
                }}>
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            fontSize: 16,
                            textAlign: "center"
                        }}>
                        <Grid doubling columns={2}>
                            <GridColumn width={7} style={{alignContent: "center", padding: isMobile ? 30 : 0}}>
                                <Image style={{width: 400, height: "auto", padding: 20, margin: "auto"}}
                                       src={process.env.PUBLIC_URL + '/Amston-Student-Secondary-Image.jpg'}/>
                            </GridColumn>
                            <GridColumn width={9} style={{
                                justifyContent: "center",
                                alignContent: "center",
                                padding: isMobile ? 30 : 0
                            }}>

                                <Header as={'h3'} style={{cursor: "pointer", color: "#990001"}}>
                                    Why Choose Amston?
                                </Header>
                                <Item.Group unstackable>
                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/check.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Convenient</Item.Header>
                                            <Item.Extra>Skip the hassle of renting a truck or hauling heavy
                                                boxes.</Item.Extra>
                                        </Item.Content>
                                    </Item>

                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/check.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Trusted</Item.Header>
                                            <Item.Extra>Dependable, insured, friendly service .</Item.Extra>
                                        </Item.Content>
                                    </Item>
                                    <Item>
                                        <Item.Image className={"item-image"} size='tiny'
                                                    src={process.env.PUBLIC_URL + '/check.png'}/>
                                        <Item.Content style={{textAlign: "left"}}>
                                            <Item.Header as='a'>Flexible</Item.Header>
                                            <Item.Extra>We’ll pick up/deliver when it works for you.</Item.Extra>
                                        </Item.Content>
                                    </Item>
                                </Item.Group>
                                <p style={{textAlign: "left", color: "black", fontSize: 14, fontWeight: 'normal'}}>
                                    Looking for reliable summer storage solutions for your college or prep school belongings? Amston makes storing your items easy with <strong>free boxes, free pickup, and free delivery</strong>, all for a <strong>flat-rate
                                    price</strong>. Skip the hassle of renting a truck or hauling heavy boxes with our <strong>convenient
                                    storage services</strong>.
                                    Our <strong>trusted, insured, and friendly service ensures</strong> your belongings are in safe hands. Plus, with <strong>flexible
                                    scheduling</strong>, we’ll pick up and deliver your items whenever it’s most convenient for you.
                                    <br/>
                                    <strong>Affordable, Secure, and Easy</strong> – Store with Amston today!
                                </p>
                                <Button className={'menu_button'}
                                        onClick={()=>{
                                            props.router.navigate('/getstarted')

                                        }}>
                                    Get a FREE Estimate Today!</Button>
                            </GridColumn>


                        </Grid>
                    </div>
                </div>
            </Container>
            <br/>
            <br/>
            <footer>
                <Grid doubling columns={"equal"}
                      style={{
                          paddingLeft: isMobile ? 10 : 100,
                          paddingRight: isMobile ? 10 : 100,
                          alignContent: "center"}}>

                    <GridColumn style={{
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}}>
                            <Image style={{height: 150, width: "auto"}}
                                   src={process.env.PUBLIC_URL + '/Amston-Commercial-Logo_512_Black_and_white.png'}/>
                        </Header>
                    </GridColumn>
                    <GridColumn style={{
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial",
                        float: "right"
                    }}>
                        <div style={{float: "right"}}>
                            <p className={"contact"}><Icon name='phone' size='large'/> (860) 920-5377</p>
                            <p className={"contact"}><Icon name='map pin' size='large'/> Wallingford, CT</p>
                            <p className={"contact"}><Icon name='mail' size='large'/> info @ amstonstudentstorage .com</p>
                        </div>
                    </GridColumn>
                </Grid>
                <p>
                    Amston Student Storage 2025
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(Landing);
